import React from 'react';
import PropTypes from 'prop-types';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
// import { colors } from '../../styles';

const styles = css`
  margin: 30px 0;
  @media(min-width: 992px) {
    margin: 60px 0;
  }
`;

const PlanDescription = ({ plan }) => {
  return (
    <div className={styles}>
      <div className="detail-content">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-8 mx-lg-auto">
              <h4 className="Detail_sectionHeadingInner">About This Plan</h4>
              <p className="text-lg-center" dangerouslySetInnerHTML={SanitizeHtml(get(plan, 'description'))} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PlanDescription.propTypes = {
  plan: PropTypes.object.isRequired,
};

export default PlanDescription;



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/PlanDescription.js